
import Cookies from 'js-cookie'
export default function authHeader() {
  const user = JSON.parse(Cookies.get("user"));
  if (user && user.jwt) {
    return { Authorization: 'Bearer ' + user.jwt };
  } else {
    return {};
  }
}